"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterBOMAndAssemblyChargeBySearchText = void 0;
const filterBOMAndAssemblyChargeBySearchText = (bomGroups, assemblyCharge, searchText) => {
    var _a, _b, _c;
    if (!(searchText === null || searchText === void 0 ? void 0 : searchText.trim())) {
        return {
            groups: bomGroups || [],
            assemblyCharge: assemblyCharge && Object.keys(assemblyCharge).length > 0 ? assemblyCharge : undefined
        };
    }
    const normalizedSearchText = searchText.toLowerCase().trim();
    const filteredGroups = bomGroups
        .map((group) => {
        const matchedItems = group.items.filter((item) => {
            var _a, _b, _c;
            const itemMatches = ((_a = item.item_number) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(normalizedSearchText)) ||
                ((_b = item.description) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(normalizedSearchText));
            const serviceMatches = (_c = item.services) === null || _c === void 0 ? void 0 : _c.some((service) => {
                var _a, _b;
                return ((_a = service.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(normalizedSearchText)) ||
                    ((_b = service.item_number) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase().includes(normalizedSearchText));
            });
            return itemMatches || serviceMatches;
        });
        return Object.assign(Object.assign({}, group), { items: matchedItems });
    })
        .filter((group) => group.items.length > 0);
    let filteredAssemblyCharge = undefined;
    if (assemblyCharge && Object.keys(assemblyCharge).length > 0) {
        const assemblyChargeMatches = ((_a = assemblyCharge.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(normalizedSearchText)) ||
            ((_b = assemblyCharge.description) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(normalizedSearchText)) ||
            ((_c = assemblyCharge.item_number) === null || _c === void 0 ? void 0 : _c.toString().toLowerCase().includes(normalizedSearchText));
        if (assemblyChargeMatches) {
            filteredAssemblyCharge = assemblyCharge;
        }
    }
    return {
        groups: filteredGroups,
        assemblyCharge: filteredAssemblyCharge
    };
};
exports.filterBOMAndAssemblyChargeBySearchText = filterBOMAndAssemblyChargeBySearchText;
